import { ca, ga } from './supply/action-helpers'

export const actionsShell = ga('shell', {
	replacePage: ca<React.FunctionComponent | React.ComponentClass>(),
})
